import { render, staticRenderFns } from "./set-weeks-modal.vue?vue&type=template&id=3657b35b&scoped=true&"
import script from "./set-weeks-modal.vue?vue&type=script&lang=js&"
export * from "./set-weeks-modal.vue?vue&type=script&lang=js&"
import style0 from "./set-weeks-modal.vue?vue&type=style&index=0&id=3657b35b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3657b35b",
  null
  
)

export default component.exports